import { SearchForSuggestionsResult } from 'aws-sdk/clients/location';

import { SelectOption } from 'src/common/primitives/Select';

export function suggestionResultToSelectOption(
  suggestion: SearchForSuggestionsResult
): SelectOption {
  return {
    label: suggestion.Text,
    value: suggestion.PlaceId ? suggestion.PlaceId : suggestion.Text,
  };
}
